import React from "react";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import BrandedThemeProvider from "./app/BrandedThemeProvider";
import { AppRoutes } from "./app/routes";

function App() {
  return (
    <BrandedThemeProvider>
      <CssBaseline />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </BrandedThemeProvider>
  );
}

export default App;
